import SelectList from "../../assets/SelectList";
import React from "react";
import {Button, RichCell, Switch} from "@vkontakte/vkui";
import {AdaptivityContext} from "../../assets/constants";
import * as constants from "../../assets/constants";
import StandCollectionsManagers from "../../api/references/managers/standcollectionsManagers";
import StandCollectionQuickForm from "../standcollections/StandCollectionQuickForm";
import withOffline from "../../components/withOffline";

/**
 * Выбор коллекции для комплектации. Свой список, без подмешивания клиентов
 * из localStorage и без selectListObject, который слушает мониторинг.
 */
class KitCollectionPicker extends SelectList {

    getItems(search_ = '', append = false, page = 1) {
        const search = search_ ? search_ : this.state.search
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page
        }

        const exclude = (this.props.excludeIds || []).filter(id => Number(id) > 0)
        const selected = new Set((this.props.selectedIds || []).map(id => Number(id)))
        this.setState({loading: true})
        StandCollectionsManagers.getList({
            show_deleted: false,
            isOffline: this.props.isOffline,
            search,
            page,
            epp: AdaptivityContext.isMobile ? 10 : 20,
            exclude_ids: exclude.join(','),
        }).then((response) => {
            const items = append ? this.state.items : []
            ;(response.data.results || []).forEach((el) => {
                el.name = el.title
                el.uid = el.id
                el.descr = el.descr
                el.checked = selected.has(Number(el.id))
                items.push(el)
            })
            this.setState({
                items,
                loading: false,
                cnt_items: response.data.iTotalRecords,
                totalPages: response.data.iTotalPages,
            })
        }).catch(() => this.setState({loading: false}))
    }

    selectObject(index) {
        const items = this.state.items.slice()
        const item = items[index]
        if (!item) return
        items[index] = {...item, checked: !item.checked}
        this.setState({items})
    }

    renderRow(item, index) {
        return <RichCell key={'kit_coll_' + item.id}
                         onClick={() => this.selectObject(index)}
                         multiline
                         subhead={item.descr}
                         after={<Switch checked={!!item.checked}
                                        onClick={(event) => {
                                            event.stopPropagation()
                                            this.selectObject(index)
                                        }}/>}>
            {item.name}
        </RichCell>
    }

    closeList = () => {
        const items = this.state.items || []
        this.setState({search: '', page: 1, items: []})
        if (this.props.onConfirm) {
            this.props.onConfirm(items)
            return
        }
        this.props.modalBack()
    }

    renderCreateForm() {
        return <div>
            <div style={{padding: '0 16px 8px'}}>
                <Button mode="outline" size="s"
                        onClick={() => this.props.setActiveModal(constants.MODAL_SELECT_LIST)}>
                    К списку
                </Button>
            </div>
            <StandCollectionQuickForm
                collection={null}
                existingTitles={this.props.existingTitles || []}
                isOffline={this.props.isOffline}
                onSaved={(data) => {
                    const item = {
                        ...data,
                        name: data.title,
                        uid: data.id,
                        checked: true,
                    }
                    this.setState(state => ({
                        items: [item, ...(state.items || []).filter(el => Number(el.id) !== Number(item.id))],
                    }))
                    this.props.setActiveModal(constants.MODAL_SELECT_LIST)
                }}
                onCancel={() => this.props.setActiveModal(constants.MODAL_SELECT_LIST)}
            />
        </div>
    }

    render() {
        return <div>
            {super.render()}
            {this.props.activeModal === constants.MODAL_SELECT_LIST &&
                <div style={{position: 'fixed', zIndex: 10000000000001, left: 16, bottom: 88}}>
                    <Button size="m" mode="outline"
                            onClick={() => {
                                if (this.props.isOffline) {
                                    window.postMessage({
                                        type: 'error',
                                        text: 'В режиме offline нельзя менять коллекции',
                                    })
                                    return
                                }
                                this.props.setActiveModal(constants.MODAL_SELECT_LIST_ADD)
                            }}>
                        Новая коллекция
                    </Button>
                </div>}
        </div>
    }
}

export default withOffline(KitCollectionPicker)
